'use client'
import IconMenu from "@/assets/icon/menu.svg";

import React, {ReactNode, useState} from "react";
import { NavClose } from "./NavClose";

export function NavToggle({nav}: {nav: ReactNode}) {
  const [showNav, setShowNav] = useState(false);
  return <div className="-ml-3 mr-3">
    <button className="mobile-nav-button" onClick={() => setShowNav(true)} aria-label="Menü öffnen"><IconMenu /></button>
    {showNav &&
      <div>
        <NavClose onClick={() => {setShowNav(false)}} />
        {nav}
      </div>
    }
  </div>
}
